<template>
<div class="content-main">
    <div class="left-main">
        <div class="left-main-content">
            <div class="title mgt50"><span class="colorFB092B">新闻</span><span>政策</span></div>
            <div class="title-btnsList">
                <div class="sec-title">NEWS<br>
                    INFORMATION</div>
                <div class="btnsList">
                    <div :class="{'btn-child':true,'active-btn':item.isClick}" v-for="item in btnList" :key="item.text" @click="changeBtn(item)">{{item.text}}</div>
                </div>
            </div>
            <div class="left-main-box mgt40">
                <div class="child-box" v-for="(item,index) in newsList" :key="index" @mouseover="changeChild(item)">
                    <div :class="{'child-top':true,'active-top':item.isHover}" :style="{backgroundImage: `url(${item.isHover?item.imgs:''})`}">
                        <div :class="{'child-text-title':true,'active-title':item.isHover}">{{item.title}}</div>
                    </div>
                    <div class="line mglr24 mgt24"></div>
                    <div :class="{'child-date':true,'mglr24':true,'mgt24':true,'active-date':item.isHover}">{{item.date}}</div>
                    <div class="child-text mglr24">{{item.text}}</div>
                    <div :class="{'child-go':true,'mglr24':true,'mglr24':true,'mgb67':true}   " @click="goList">
                        <img src="../assets/images/active_go_child.png" alt="" width="32px" height="32px" v-if="item.isHover">
                        <img src="../assets/images/colorRed_right.png" alt="" width="14px" height="14px" v-else>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="right-main">
        <div class="tagLabel-box">
            <div class="label-top">
                <div :class="{'icon-item':true,'active-icon':item.hasClass}" v-for="(item,index) in list" :key="index" :style="{backgroundImage: `url(${item.hasClass?active_icon:default_icon})`}" @click="changeTag(item)"></div>
            </div>
            <div class="label-bottom">
                <div class="label-bottom-top">
                    <div :class="{'active-child':item.hasClass,'default-child':true}" v-for="(item,index) in list" :key="index" @click="changeTag(item)"></div>
                </div>
                <div class="label-bottom-bottom">
                    <img src="../assets/images/icon_1.png" alt="" width="27px" height="37px">
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import top_active from "../assets/images/top_active.png"
import top_default from "../assets/images/top_default.png"
import news_icon from '@/assets/images/news_icon.png'
export default {
    name: "tagNews",
    props: {
        "vdata": {
            type: Array,
            default: [],
        }

    },
    data() {
        return {
            list: [],
            btnList: [{
                id: 0,
                text: "新闻动态",
                isClick: true,
            }, {
                id: 1,
                text: "政策通知",
                isClick: false
            }],
            newsList: [{
                    id: 0,
                    imgs: news_icon,
                    title: "High quality external integrated supply chain service",
                    date: "2021-08-31",
                    text: "链接了全球优质的供应链服务商，提供费用最优，时间最优，服务最优及定制最优的供应链解决方案，更好的满足个进出口企业的需求。",
                    isHover: false,
                },
                {
                    id: 1,
                    imgs: news_icon,
                    title: "High quality external integrated supply chain service",
                    date: "2021-08-31",
                    text: "链接了全球优质的供应链服务商，提供费用最优，时间最优，服务最优及定制最优的供应链解决方案，更好的满足个进出口企业的需求。",
                    isHover: false,

                },
                {
                    id: 2,
                    imgs: news_icon,
                   title: "High quality external integrated supply chain service",
                    date: "2021-08-31",
                    text: "链接了全球优质的供应链服务商，提供费用最优，时间最优，服务最优及定制最优的供应链解决方案，更好的满足个进出口企业的需求。",
                    isHover: false,
                },
                {
                    id: 3,
                    imgs: news_icon,
                    title: "优质的外综供应链服务的优质的外综供应链服务的",
                    date: "2021-08-31",
                    text: "链接了全球优质的供应链服务商，提供费用最优，时间最优，服务最优及定制最优的供应链解决方案，更好的满足个进出口企业的需求。",
                    isHover: false,
                }
            ],
            default_icon: top_default,
            active_icon: top_active
        }
    },
    created() {
        let curr = this.vdata;
        let result = [];
        //console.log(curr,"curr")
        curr.forEach((item, index) => {
            if (index % 2 == 0) {
                result.push(item);
            }
        })
        this.list = result;
        this.changeChild(this.newsList[0])
        //console.log(this.list, "vdata")
    },
    methods: {
        goList() {
            this.$router.push("/newsList")
        },
        changeChild(tem) {
            this.newsList.forEach((item, index) => {
                if (item.id == tem.id) {
                    this.$set(this.newsList, index, {
                        id: item.id,
                        imgs: item.imgs,
                        title: item.title,
                        date: item.date,
                        text: item.text,
                        isHover: true,
                    })
                } else {
                    this.$set(this.newsList, index, {
                        id: item.id,
                        imgs: item.imgs,
                        title: item.title,
                        date: item.date,
                        text: item.text,
                        isHover: false,
                    })
                }
            })
            console.log(tem)
        },
        changeBtn(tem) {
            this.btnList.forEach((item, index) => {
                //console.log()
                if (item.id == tem.id) {
                    this.$set(this.btnList, index, {
                        id: item.id,
                        text: item.text,
                        isClick: true,
                    })
                } else {
                    this.$set(this.btnList, index, {
                        id: item.id,
                        text: item.text,
                        isClick: false,
                    })
                }
            })
            //console.log(this.btnList)
        },
        changeTag(item) {
            let curr = this.vdata;
            curr.forEach((tem, index) => {
                console.log(tem.id, item.id)
                if (tem.id == item.id) {
                    //console.log(11111)
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: true,
                    }
                } else {
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: false,
                    }
                }
            })
            let result = [];
            curr.forEach((item, index) => {
                if (index % 2 == 0) {
                    result.push(item);
                }
            })
            this.list = result;
            this.$emit('godata', {
                item,
                index: item.id
            })
            console.log(curr, "curr")
        }
    }

}
</script>

<style lang="less" scoped>
.active-icon {
    width: 22px !important;
    height: 22px !important;
}

.active-go {
    background-color: #CC1F37;
}

.child-go {
    width: 32px;
    height: 32px;
    //border:1px red solid;
    display: flex;
    justify-content: center;
    align-items: center;
}

.active-date {
    color: #000000 !important;
}

.active-title {
    color: white !important;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);
}

.child-text-title {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 28px;
    padding: 31px 24px;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    //border: 1px red solid;
}

.content-main {
    //background-color: yellowgreen;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .left-main {
        width: 100%;
        height: 100%;
        display: flex;
        //flex-direction: column;
        justify-content: center;
        align-items: center;

        .left-main-content {
            width: 1440px;
            height: 100%;
            display: flex;
            flex-direction: column;
        }

        .left-main-box {
            display: flex;
            //flex: 1;
            justify-content: space-between;
            align-items: flex-end;
            //border: 1px red solid;
            width: 100%;
            margin-top: 50px;

            .left-main-text {
                width: 50%;
                height: 240px;
                background: #FFFFFF;
                padding: 80px;
                //border:1px red solid;
            }

            .left-main-imgs {
                width: 50%;
                height: 400px;
                //border:1px red solid;
            }
        }
    }

    .right-main {
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 100%;
        padding-right: 60px;

        //background-color: rgb(167, 164, 164);
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .tagLabel-box {
            width: 40px;
            height: 100%;
            // margin-top: 160px;
            //border: 1px red solid;
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;

            .label-top {
                width: 100%;
                height: 30%;
                display: flex;
                justify-content: space-around;
                align-items: center;
                flex-direction: column;

                //border: 1px green solid;

                .icon-item {
                    width: 8px;
                    height: 8px;
                    background-size: cover;
                    background-position: center center;
                }
            }

            .label-bottom {
                width: 100%;
                height: 30%;
                //border: 1px green solid;

                .label-bottom-top {
                    width: 100%;
                    height: 80%;
                    //border: 1px red solid;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                }

                .label-bottom-bottom {
                    width: 100%;
                    height: 20%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    //border:1px red solid;
                }
            }
        }
    }
}

.colorFB092B {
    color: #FB092B;
}

.active-top {
    height: 201px !important;
    color: white !important;
    //background-color: red;
    //margin-bottom: 20px !important;
    display: flex;
    //justify-content: flex-end;
    align-items: flex-end;
    //border:1px red solid;
    border-top-right-radius: 16px;
}

.title {

    font-size: 60px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 84px;
}

.sec-title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.85);
    line-height: 26px;
}

.text-title {
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 42px;
}

.btnsList {
    display: flex;
    justify-content: space-around;
    align-items: center;

    //border:1px red solid;
    .btn-child {
        width: 98px;
        height: 32px;
        //background: #CC1F37;
        border-radius: 19px;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;

        &:last-child {
            margin-left: 32px;
        }
    }
}

.active-btn {
    background: #CC1F37;
}

.texts {
    width: 340px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    text-align: justify;
}

.btns {
    width: 118px;
    height: 42px;
    background: #CC1F37;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.line {
    border-bottom: 1px #D8D8D8 solid;
    margin-top: 20px;
    margin-bottom: 20px;
}

.btns-box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .pages {
        color: #333333;
        font-size: 14px;
    }
}

.title-btnsList {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.child-box {
    width: 338px;
    //height: 371px;
    background: #FFFFFF;
    border-radius: 0px 16px 0px 16px;
    //border: 1px red solid;
    //padding: 31px 24px;
    cursor: pointer;

    .child-top {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 28px;
        //padding:31px 24px;
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .child-date {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #999999;
        line-height: 24px;
        margin-bottom: 10px;
    }

    .child-text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        text-align: justify;
        margin-bottom: 20px;
    }
}

.mgb40 {
    margin-bottom: 40px;
}

.mgt10 {
    margin-top: 10px;
}

.mgt60 {
    margin-top: 60px;
}

.mgb30 {
    margin-bottom: 30px;
}

.mgb32 {
    margin-bottom: 32px;
}

.mgb100 {
    margin-bottom: 100px;
}

.mgr10 {
    margin-right: 10px;
}

.mgt50 {
    margin-top: 50px;
}

.mgt24 {
    margin-top: 24px !important;
}

.mglr24 {
    margin: 0 24px;
}

.mgb67 {
    margin-bottom: 67px;
}

.btn-go {
    width: 32px;
    height: 32px;
    background-color: #CC1F37;
    margin-top: 20px;
}

.default-child {
    width: 2px;
    height: 16%;
    background: rgba(255, 255, 255, 0.1);
}

.active-child {
    background: rgba(54, 169, 255, 0.5);
}

.color36A9FF {
    color: #36A9FF;
}
</style>



// WEBPACK FOOTER //
// src/components/tagNews.vue